import React from 'react';
import { motion } from 'framer-motion';

const fadeUp = {
  hidden: { opacity: 0, y: 12 },
  show: { opacity: 1, y: 0, transition: { duration: 0.24, ease: [0.2, 0.8, 0.2, 1] } }
};

/**
 * Tarjeta de KPI del Dashboard.
 * Componente presentacional puro.
 */
export function KpiCard({ icon, label, value, subtitle, testId, color }) {
  return (
    <motion.div
      variants={fadeUp}
      whileHover={{ scale: 1.02, y: -2 }}
      style={{
        background: '#fff', borderRadius: '12px', padding: '20px',
        border: '1px solid hsl(140 18% 86%)',
        boxShadow: '0 1px 4px rgba(0,0,0,0.05)',
        cursor: 'default'
      }}
    >
      <div style={{ display: 'flex', alignItems: 'flex-start', justifyContent: 'space-between', marginBottom: '12px' }}>
        <div style={{
          width: '40px', height: '40px', borderRadius: '10px',
          background: 'hsl(145 40% 90%)',
          display: 'flex', alignItems: 'center', justifyContent: 'center', fontSize: '18px'
        }}>
          {icon}
        </div>
      </div>
      <div
        data-testid={testId}
        style={{ fontSize: '32px', fontFamily: 'Space Grotesk', fontWeight: 700, color: color || '#1a5c2e', lineHeight: 1, marginBottom: '6px' }}
      >
        {value}
      </div>
      <div style={{ fontSize: '13px', fontWeight: 600, color: '#333', marginBottom: '2px' }}>{label}</div>
      {subtitle && <div style={{ fontSize: '11px', color: '#999' }}>{subtitle}</div>}
    </motion.div>
  );
}

export default KpiCard;
